/* global Sentry */

Apt.fn.make('consent', {
	/**
	 * Initialize module
	 */
	init() {
		$$('consentDeny').on('click', () => {
			if (LS.store.set('consent', false)) {
				LS.util.flash('Successfully updated privacy choices', 'success');

				try {
					gtag('consent', 'update', {
						'ad_storage': 'denied',
						'ad_user_data': 'denied',
						'ad_personalization': 'denied'
					});
				} catch (e) {
					//
				}

				try {
					Sentry.getReplay()
						.stop();
				} catch (e) {
					//
				}

				return;
			}

			LS.util.warn('Error updated privacy choices');
		}, {
			namespace: 'consent'
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('consent', this);
	}
});